import { Button, Modal } from 'native-base';
import React, { useState } from 'react';
import { DoctorDispenseSummaryModal } from './DoctorDispenseSummaryModal';
import { Icon } from '../../Common/components/Icon';
import { faBookMedical } from '@fortawesome/pro-solid-svg-icons/faBookMedical';

interface IDoctorDispenseSummaryProps {
  customerID: string;
  onLoadDocumentCLicked: (documentID: string, repositoryID: string | null | undefined) => void;
}
export function DoctorDispenseSummary({ customerID, onLoadDocumentCLicked }: IDoctorDispenseSummaryProps) {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        leftIcon={<Icon icon={faBookMedical} />}
        size={'sm'}
        variant={'outline'}
        onPress={() => setShowModal(true)}
      >
        My Health Record - Prescription View
      </Button>

      <Modal isOpen={showModal} size={'full'} onClose={() => setShowModal(false)}>
        {showModal && <DoctorDispenseSummaryModal customerID={customerID} onLoadDocumentCLicked={onLoadDocumentCLicked} />}
      </Modal>
    </>
  );
}
